import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const steps = [
  {
    num: "01",
    title: "Precision Training",
    description:
      "Strength-focused programming designed for muscle growth, fat loss, and visible body composition change.",
  },
  {
    num: "02",
    title: "Strategic Nutrition",
    description:
      "Simple, personalized nutrition guidance that matches your goal, schedule, and recovery needs.",
  },
  {
    num: "03",
    title: "Elite Accountability",
    description:
      "Coaching, check-ins, and feedback to keep you locked in until the transformation is complete.",
  },
];

export default function DVXMethod() {
  const { theme } = useTheme();
  return (
    <section
      className="py-8 relative md:py-8 mb-24 bg-[var(--dvx-bg)] transition-colors duration-300 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/images/success_trans_bg.png')" }}
    >
      {/* Overlay */}
      <div
        className={`absolute inset-0 transition-all duration-300 ${
          theme === "dark" ? "bg-black/60" : "bg-white/20"
        }`}
      ></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-14"
        >
          <span className="text-[var(--dvx-primary)] font-oswald text-sm uppercase tracking-widest">
            The DVX Method
          </span>
          <h2 className="mt-4 font-oswald text-4xl md:text-5xl font-bold text-[var(--dvx-text)] uppercase tracking-tight max-w-2xl">
            The Transformation System That Gets Results
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12 }}
              className="bg-[var(--dvx-surface)] border border-[var(--dvx-border)] p-8 hover:border-[var(--dvx-primary)]/50 transition-colors duration-300"
            >
              <div className="font-oswald text-4xl font-bold text-[var(--dvx-primary)] mb-4">
                {step.num}
              </div>
              <h3 className="font-oswald text-xl font-bold text-[var(--dvx-text)] uppercase tracking-wide mb-3">
                {step.title}
              </h3>
              <p className="text-[var(--dvx-text-muted)] font-manrope text-sm leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
